import * as Sentry from '@sentry/react';

import packageInfo from '../../package.json';
import { SentryUser } from './SentryUser';

const CMD_URL = process.env.CMD_URL || '123';

export class SentryClient {
  static initialize(): void {
    Sentry.init({
      dsn: 'https://e1333b42a63046228464e76686782495@o1355868.ingest.sentry.io/4504320630521856',
      tracesSampleRate: 0.1,
      debug: false,
      release: packageInfo.version,

      beforeSend(event) {
        //Exclude localhost and local development environments
        if (
          typeof window !== 'undefined' &&
          (window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname === 'stag-samsung.norlysplay.dk')
        ) {
          return null;
        }

        //Only allow major and minor releases (X.Y.Z format)
        const release = packageInfo.version.toString();
        if (!/^\d+\.\d+\.\d+$/.test(release)) {
          return null;
        }

        return event;
      }
    });
  }

  static setUser(user: SentryUser): void {
    Sentry.setUser({
      id: user.id
    });

    Sentry.addBreadcrumb({
      level: 'info',
      type: 'user',
      category: 'Authentication',
      message: 'Logged in'
    });
  }

  static removeUser(): void {
    Sentry.setUser(null);
    Sentry.addBreadcrumb({
      level: 'info',
      type: 'user',
      category: 'Authentication',
      message: 'Logged out'
    });
  }

  static setModel(model: string): void {
    Sentry.setTag('TV_MODEL', model);
  }

  // Hvad der skal ske med denne funktion efter cmd er nedlagt er ikke klart. Det gøres i https://norlys-ks.atlassian.net/browse/CUS-86770
  // static addHTTPRequest(
  //   cmd: CmdActions['cmd'],
  //   method: 'get' | 'post',
  //   requestWasSuccessful = true
  // ): void {
  //   Sentry.addBreadcrumb({
  //     type: 'http',
  //     category: 'WebTV Backend',
  //     level: requestWasSuccessful ? 'info' : 'error',
  //     data: {
  //       url: CMD_URL,
  //       method: method,
  //       cmd: cmd
  //     }
  //   });
  // }

  static trackLongLoadingSpinner(context: SpinnerDebugContext): void {
    Sentry.captureMessage('Player loading spinner exceeded threshold', {
      fingerprint: [String(Date.now())], // avoid event being ignored as duplicate by sentry
      level: 'warning',
      tags: {
        spinner_type: context.spinnerType
      },
      extra: {
        duration_ms: context.durationMs,
        stream_type: context.streamType,
        channel_sid: context.channelSid,
        event_id: context.eventId,
        media_id: context.mediaId,
        content_id: context.contentId,
        channel_name: context.channelName,
        content_title: context.contentTitle,
        tv_model: context.tvModel,
        tizen_version: context.tizenVersion,
        connection_type: context.connectionType,
        app_version: context.appVersion,
        device_uuid: context.deviceUuid,
        has_stream_error: context.hasStreamError,
        error_message: context.errorMessage,
        buffering_events_sent: context.bufferingEventsSent
      }
    });
  }
}

export interface SpinnerDebugContext {
  spinnerType: 'initial_load' | 'buffering';
  durationMs: number;
  streamType?: string;
  channelSid?: number;
  eventId?: number;
  mediaId?: number;
  contentId?: number;
  channelName?: string;
  contentTitle?: string;
  tvModel?: string;
  tizenVersion?: string;
  connectionType?: string;
  appVersion?: string;
  deviceUuid?: string;
  hasStreamError: boolean;
  errorMessage?: string;
  bufferingEventsSent: number;
}
